import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import classNames from 'classnames';
import ClipLoader from 'react-spinners/ClipLoader';

import { useFormatMessage, useFormatDate } from 'hooks';
import Table from 'components/Table';
import {
  fetchEntities,
  entitiesCleanUp,
} from 'state/actions/stationsUsersGroups';
import paths from 'pages/Router/paths';

import { search as searchInObject } from 'utils';

import classes from './index.module.scss';

const Users = () => {
  const entitiesName = 'stationsUsersGroups';
  const i18nEntityName = 'StationsUsersGroups';
  const PATH_ENTITIES = paths.STATIONS_USERS_GROUPS;
  const PATH_ADD_ENTITY = paths.ADD_STATIONS_USERS_GROUP;

  const { entitiesList, isAuth, error, loading } = useSelector(
    (state) => ({
      entitiesList: state[entitiesName].data,
      isAuth: state.auth.userData.role > 0,
      error: state[entitiesName].error,
      loading: state[entitiesName].loading,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  const [search, setSearch] = useState('');

  useEffect(() => {
    if (isAuth) {
      dispatch(fetchEntities());
    }

    return () => dispatch(entitiesCleanUp());
  }, [dispatch, isAuth]);

  const columns = [
    {
      Header: useFormatMessage(`${i18nEntityName}.name`),
      accessor: 'name',
    },
    {
      Header: useFormatMessage(`${i18nEntityName}.created`),
      accessor: 'createdAt',
      Cell: ({ row }) => (
        <small className="has-text-grey is-abbr-like">
          {useFormatDate(row.original.createdAt)}
        </small>
      ),
    },
    {
      Header: '',
      id: 'actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <div className="buttons is-right">
          <Link
            to={`${PATH_ENTITIES}/${row.original.id}/profile`}
            className="button is-small is-primary"
          >
            <span className="icon is-small">
              <i className="mdi mdi-eye" />
            </span>
          </Link>
        </div>
      ),
      disableSortBy: true,
    },
  ];

  const data = search
    ? entitiesList.filter((el) => {
        const clonedElem = { ...el };

        // Delete these fields from search
        delete clonedElem.id;
        delete clonedElem.usersIds;
        delete clonedElem.stationsIds;
        return searchInObject(clonedElem, search);
      })
    : entitiesList;
  const redirect = !isAuth && <Redirect to={paths.ROOT} />;

  return (
    <>
      {redirect}

      <section className="hero is-hero-bar">
        <div className="hero-body">
          <div className="level">
            <div className="level-left">
              <div className="level-item">
                <h1 className="title">
                  {useFormatMessage(`${i18nEntityName}.entities`)} (
                  {entitiesList.length})
                </h1>
              </div>
            </div>
            <div className="level-right">
              <div className="level-item">
                <Link to={PATH_ADD_ENTITY} className="button">
                  {useFormatMessage(`${i18nEntityName}.newEntity`)}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section is-main-section">
        <div className="card has-table has-mobile-sort-spaced">
          <header className="card-header">
            <p className={classNames('card-header-title', classes.tableHeader)}>
              <span>{useFormatMessage(`${i18nEntityName}.search`)}</span>
              <input
                type="text"
                className="input"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </p>
          </header>
          <div className="b-table">
            {loading ? <ClipLoader /> : <Table columns={columns} data={data} />}
            {error && 'Show error'}
          </div>
        </div>
      </section>
    </>
  );
};

export default Users;
